export function resolvePortalSenderName({
	portalInstanceId,
	portalInstances,
	workspaceName,
}: {
	portalInstanceId?: string | null
	portalInstances?: readonly { id: string; name: string }[]
	workspaceName?: string | null
}): string {
	const portal = portalInstanceId
		? portalInstances?.find((instance) => instance.id === portalInstanceId)
		: null
	return portal?.name ?? workspaceName ?? ""
}
